import { render, staticRenderFns } from "./TransactionsDataTable.vue?vue&type=template&id=47301a62"
import script from "./TransactionsDataTable.vue?vue&type=script&lang=js"
export * from "./TransactionsDataTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionsDataTable.vue?vue&type=style&index=0&id=47301a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports